import { useMemo } from 'react'

import { Box } from '@material-ui/core'

import { VideoOverlay } from '@guidde-co/shared.video-player.video-overlay'

import { PlaybookType, VideoRefType } from 'app/types'
import { paths } from 'app/paths'

import { useBoolean, UseBooleanType } from 'hooks'

import { ShareOnlyDialog } from 'UI/Components'

type Props = {
    showVideoOverlay: UseBooleanType
    videoRef: VideoRefType
    playbook: PlaybookType
    watchLabel?: string
    onWatchClick?: () => void
}

export const VideoOverlayWrapper = ({
    watchLabel = 'Watch Again',
    showVideoOverlay,
    videoRef,
    playbook,
    onWatchClick
}: Props) => {
    const showShare = useBoolean()
    const { id, uploadedByOrgId } = playbook

    const utmParams = useMemo(() => {
        const query = new URLSearchParams()

        query.append('utm_source', 'guidde-app')
        query.append('utm_medium', 'public-end-screen')
        query.append('utm_campaign', 'get+started')
        query.append('utm_term', id)
        query.append('utm_content', uploadedByOrgId)

        return query.toString()
    }, [id, uploadedByOrgId])

    const startPlaying = () => {
        if (!videoRef.current) return

        showVideoOverlay.setFalse()
        videoRef.current.currentTime = 0
        videoRef.current.play()
    }

    if (showVideoOverlay.isFalse) return null

    return (
        <Box
            style={{
                width: '100%',
                height: '100%',
                position: 'absolute',
                top: 0
            }}
        >
            <VideoOverlay
                isVisible={showVideoOverlay.isTrue}
                onWatch={() => {
                    onWatchClick?.()
                    startPlaying()
                }}
                watchLabel={watchLabel}
                title="How-To Videos Made Simple"
                subtitle="Instantly capture a video like this one for any workflow or software."
                useGuiddeForFreeLink={paths.signup + `?${utmParams}`}
                onShare={showShare.setTrue}
            />
            {showShare.isTrue && (
                <ShareOnlyDialog
                    isOpen={true}
                    onDone={() => {}}
                    onClose={showShare.setFalse}
                    playbook={playbook}
                    title={`Share your ${playbook.isPlaylist ? 'playlist' : 'video'}`}
                    subtitle={`Invite people to view your ${
                        playbook.isPlaylist ? 'Playlist' : 'Playbook'
                    }`}
                    warning=""
                />
            )}
        </Box>
    )
}
